import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Grid, Form, Message } from 'semantic-ui-react';
import ImageUploader from "react-images-upload";
import { createFuneralHome } from '../actions/funeralHomeActions';

const onboardPage = (props) => {
  const [funeralHome, setFuneralHome] = useState({
    name: "",
    billingAddress: {
      street: "",
      city: "",
      postalCode: "",
      province: "Ontario",
      country: "Canada"
    },
    phone: "",
    contactEmail: "",
    livestreamEmail: "",
    flowerShopLink: "",
    baseUrl: "",
    googleCalendarId: "c_r8kg6ckvfck5bcgg5mnc3bevj8@group.calendar.google.com",
  });
  const [logo, setLogo] = useState(null);
  const [livestreamEventImage, setLivestreamEventImage] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const form = new FormData();
    form.append("logo", logo);
    form.append("image", livestreamEventImage);

    props.createFuneralHome(funeralHome, form);
  };

  const onDropLogo = (pictureFiles, pictureDataURLs) => {
    setLogo(pictureFiles[0]);
  }

  const onDropImage = (pictureFiles, pictureDataURLs) => {
    setLivestreamEventImage(pictureFiles[0]);
  }

  return (
    <div style={{ padding: 50 }}>
      <Form onSubmit={handleSubmit} error={props.funeralHome.error} success={props.funeralHome.success}>
        <Form.Input fluid label='Funeral Home Name' placeholder='Name' value={funeralHome.name} onChange={(e) => setFuneralHome({ ...funeralHome, name: e.target.value })} required />
        <Form.Group widths='equal'>
          <Form.Input type='email' fluid label='Contact Email' placeholder='Email' value={funeralHome.contactEmail} onChange={(e) => setFuneralHome({ ...funeralHome, contactEmail: e.target.value })} />
          <Form.Input type='phone' fluid label='Contact Phone' placeholder='Phone #' value={funeralHome.phone} onChange={(e) => setFuneralHome({ ...funeralHome, phone: e.target.value })} />
          <Form.Input type='url' fluid label='Wordpress Site URL' placeholder='Wordpress Site URL' value={funeralHome.baseUrl} onChange={(e) => setFuneralHome({ ...funeralHome, baseUrl: e.target.value })} />
        </Form.Group>
        <Form.Group widths='equal'>
          <Form.Input type='email' fluid label='Livestream Email' placeholder='Email' value={funeralHome.livestreamEmail} onChange={(e) => setFuneralHome({ ...funeralHome, livestreamEmail: e.target.value })} />
          <Form.Input type='url' fluid label='Flowershop Link' placeholder='Enter Url' value={funeralHome.flowerShopLink} onChange={(e) => setFuneralHome({ ...funeralHome, flowerShopLink: e.target.value })} />
          <Form.Input fluid label='Google Calendar ID' placeholder='Copy paste from your Google account' value={funeralHome.googleCalendarId} onChange={(e) => setFuneralHome({ ...funeralHome, googleCalendarId: e.target.value })} />
        </Form.Group>
        <Form.Input fluid label='Billing Address' placeholder='Street' value={funeralHome.billingAddress.street} onChange={(e) => setFuneralHome({ ...funeralHome, billingAddress: { ...funeralHome.billingAddress, street: e.target.value} })} />
        <Form.Group widths='equal'>
          <Form.Input fluid placeholder='City' value={funeralHome.billingAddress.city} onChange={(e) => setFuneralHome({ ...funeralHome, billingAddress: { ...funeralHome.billingAddress, city: e.target.value} })} />
          <Form.Input fluid placeholder='Postal Code' value={funeralHome.billingAddress.postalCode} onChange={(e) => setFuneralHome({ ...funeralHome, billingAddress: { ...funeralHome.billingAddress, postalCode: e.target.value} })} />
          <Form.Input fluid placeholder='Province' value={funeralHome.billingAddress.province} onChange={(e) => setFuneralHome({ ...funeralHome, billingAddress: { ...funeralHome.billingAddress, province: e.target.value} })} />
          <Form.Input fluid placeholder='Country' value={funeralHome.billingAddress.country} onChange={(e) => setFuneralHome({ ...funeralHome, billingAddress: { ...funeralHome.billingAddress, country: e.target.value} })} />
        </Form.Group>
        <Grid columns={2}>
          <Grid.Row>
              <Grid.Column>
                <ImageUploader
                  withIcon={true}
                  buttonText="Upload Logo"
                  onChange={onDropLogo}
                  imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif"]}
                  maxFileSize={5242880}
                  withPreview
                  singleImage
                />
              </Grid.Column>
              <Grid.Column>
                <ImageUploader
                  withIcon={true}
                  buttonText="Upload Livestream image"
                  onChange={onDropImage}
                  imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif"]}
                  maxFileSize={5242880}
                  withPreview
                  singleImage
                />
              </Grid.Column>
          </Grid.Row>
        </Grid>
        <Form.Button style={{ float: 'right' }} color="black">Create</Form.Button>
        <Message
          error
          header='Something went wrong'
          content={props.funeralHome.message}
        />
        <Message
          success
          header='Success'
          content='Created Funeral Home'
        />
      </Form>
    </div>
  );
};

const mapStateToProps = state => ({
  funeralHome: state.funeralHome,
});

const mapDispatchToProps = {
  createFuneralHome,
};

export default connect(mapStateToProps, mapDispatchToProps)(onboardPage);